// In your Logout component
import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import config from "../config";

function Logout({ setIsAuthenticated }) {
  useEffect(() => {
    // Make a POST request to the backend logout endpoint
    fetch(`${config.apiUrl}adminapi.php?option=3`, {
      method: "POST",
      credentials: "include", // Include credentials (e.g., cookies)
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "User logged out successfully") {
          setIsAuthenticated(null); // Update user state to indicate not logged in
        }
      })
      .catch((error) => console.error("Logout error:", error));
  }, [setIsAuthenticated]);

  // Redirect to the home page after successful logout
  return <Redirect to="/login" />;
}

export default Logout;
